import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import CategoryDetail from './pages/CategoryDetail';
import Showroom from './pages/Showroom';
import Contact from './pages/Contact';
import Anbefalinger from './pages/Anbefalinger';
import Messesystemer from './pages/Messesystemer';
import Specialdesign from './pages/Specialdesign';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-white font-sans antialiased">
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kategori/:slug" element={<CategoryDetail />} />
          <Route path="/showroom" element={<Showroom />} />
          <Route path="/messesystemer" element={<Messesystemer />} />
          <Route path="/specialdesign" element={<Specialdesign />} />
          <Route path="/anbefalinger" element={<Anbefalinger />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
